import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import Amplify from "aws-amplify";
import aws_exports from "./aws-exports";
import { Capacitor } from '@capacitor/core';
import { enableTopBannerSwalSwipeDismiss } from './app/utils/swal-top-banner-swipe-dismiss';
import { forceSwipeToCloseOnAllModals } from './app/utils/force-swipe-to-close-modals';

// Capture the earliest practical JavaScript timestamp before Angular starts.
// AppQualityService uses it to measure real cold-start-to-interactive time.
(window as any).__laniakeaBootStartedAt = performance.now();

// Verbose Capacitor bridge logging is useful locally but adds work and can
// expose implementation details in distributed binaries.
Capacitor.DEBUG = !environment.production;


Amplify.configure(aws_exports);
enableTopBannerSwalSwipeDismiss();
forceSwipeToCloseOnAllModals();
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));

